import config from 'config';

const LOAD = 'greyhound-racing/greyhound/LOAD';
const LOAD_SUCCESS = 'greyhound-racing/greyhound/LOAD_SUCCESS';
const LOAD_FAIL = 'greyhound-racing/greyhound/LOAD_FAIL';

const initialState = {
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        greyhound: action.result[0]
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    default:
      return state;
  }
}

export function isLoading(globalState) {
  return globalState.greyhoundRacing
      && globalState.greyhoundRacing.greyhound
      && globalState.greyhoundRacing.greyhound.loading;
}

export function load(name) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => client.get(`${config.api.greyhoundRacing.loadGreyhound}`,
      {
        params : {
          name: name
        }
      }
    )
  };
}

export function get(state) {
  return state.greyhoundRacing.greyhound.greyhound;
}



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/reducers/greyhound.js